'use client'
import React, {useEffect, useRef, useState} from 'react';
import styled from 'styled-components';
import Modal from "react-bootstrap/Modal";
import {Col, Container, Row} from "react-bootstrap";
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import reactHtmlParser from "react-html-parser";

const PopupV1 = ({
                     show,
                     handleClose,
                     no_img,
                     item,
                     title,
                     description,
                     data,
                     subtitle,
                     img
                 }) => {


    let [open, setOpen] = useState(false);
    let [videoId, setVideo] = useState('');
    const modalRef = useRef(null);


    const popupData = data;
    const [winWidth, setWinWidth] = useState(true)
    useEffect(() => {
        if (window.innerWidth > 767) {
            setWinWidth(true)
        } else {
            setWinWidth(false)
        }
        window.addEventListener("resize", () => {
            if (window.innerWidth > 767) {
                setWinWidth(true)
            } else {
                setWinWidth(false)
            }
        });
    }, [])




    return (

        <StyledModal>
            <Modal
                show={show}
                item={item}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                className="gph_modal popup-version-one"
            >
                <SimpleBar className="main_scroll" style={{height: '100vh'}}>
                    <Modal.Body>
                        <Container>
                            <Row className={'for-close'}>
                                <h2>{reactHtmlParser(title)}</h2>
                                <div onClick={handleClose} className="modal-close ">
                                    <img src="/images/static/modal-close.svg" alt=""/>
                                </div>

                            </Row>
                        </Container>
                        <Container>
                            <Row>
                                <Col sm={12} className="modal-data__img">
                                    <div className="modal-data__img__left">
                                        <img src={popupData?.images?.[0]?.full_path}/>
                                    </div>
                                    <div className="modal-data__img__right">
                                        <h4>{reactHtmlParser(popupData?.data?.subtitle)}</h4>
                                        <p>{reactHtmlParser(popupData?.data?.short_desc)}</p>
                                    </div>
                                </Col>
                            </Row>
                            <Row>


                                <div className="modal-data d-flex">


                                <Col sm={12} className='modal-data__content'>


                                        <div className="scroll-div">
                                            {typeof window !== 'undefined' && window.innerWidth > 767 ?
                                                <SimpleBar autoHide={true} style={{maxHeight: 'calc(100svh - 100px)'}}>
                                                    {/*{*/}
                                                    {/*    reactHtmlParser(popupData?.data?.description)*/}
                                                    {/*}*/}
                                                    <p>{reactHtmlParser(popupData?.data?.description)}  </p>                                              </SimpleBar>
                                                :
                                                <>
                                                    <p>{reactHtmlParser(popupData?.data?.description)}  </p>

                                                </>
                                            }
                                        </div>


                                    </Col>


                                </div>
                            </Row>
                        </Container>
                    </Modal.Body>
                </SimpleBar>
            </Modal>
        </StyledModal>

    )
};


const StyledModal = styled.div`
    .modal-dialog {
        margin: 0;
    }

    h4 {
        letter-spacing: 1.5px;
    }

`;


export default React.memo(PopupV1);
